import { useDisclosure } from '@chakra-ui/hooks';
import React from 'react';

import {
  CmButton,
  CmModal,
  CmModalBody,
  CmModalFooter,
  CmTable,
  CmTableBodyRow,
  CmTableHeader,
  CmTbody,
  CmTd,
  CmTh,
} from '@/components/uiParts';
import { PosDataLevel, PosOption } from '@/domain/models/Pos';
import { PosDataFactory } from '@/pages/externals/pos-connect/factories';
import {
  mappingPosDataLevel,
  MappingPosDataLevelTds,
  MappingPosDataLevelThs,
  PosItemAndHandlePos,
  posItemColumn,
} from '@/services/Pos';
import { usePosUpload } from '@/services/Pos/hooks';

interface Props {
  confirmPosItems: PosItemAndHandlePos[];
  posDataLevel: PosDataLevel;
  posProviderId: number;
  posOption?: PosOption;
  isDisabledUpdateButton: boolean;
  reFetchPosItems: () => void;
}
export const PosCodeUpdateModal: React.VFC<Props> = ({
  confirmPosItems,
  posDataLevel,
  posProviderId,
  posOption,
  isDisabledUpdateButton,
  reFetchPosItems,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const posDataUpload = usePosUpload();
  const handleUpdatePosCode = async (
    providerId: number,
    posItems: PosItemAndHandlePos[]
  ) => {
    const uploadPosData =
      PosDataFactory.createUploadPosDataFromItemTable(posItems);

    await posDataUpload(providerId, uploadPosData);
    alert('登録されました');
    reFetchPosItems();
    onClose();
  };

  return (
    <>
      {/*
       // @ts-ignore TS2590 */}
      <CmButton
        width={100}
        mb={2}
        onClick={onOpen}
        isDisabled={isDisabledUpdateButton}
      >
        更新
      </CmButton>
      <CmModal
        title={`以下の${posItemColumn.posItemCode.label}を登録しますか？`}
        headerSize="md"
        size="4xl"
        {...{ isOpen, onClose }}
      >
        <CmModalBody>
          <CmTable>
            <CmTableHeader>
              <CmTh>{posItemColumn.itemName.label}</CmTh>
              {/* TODO 互換性がないというエラーが出るため、下記`as`のHACK的なやり方で対応をする。typescriptのverv4.3.5であれば解消できる様子なのでその際にasを削除対応をとる */}
              {(
                mappingPosDataLevel[posDataLevel]
                  .ths as MappingPosDataLevelThs[]
              ).map((th) => (
                <CmTh key={th}>{th}</CmTh>
              ))}
              <CmTh>{posItemColumn.posItemCode.label}</CmTh>
              {posOption?.type === 'promotion' &&
                posOption.value === 'buy_one_get_one_free' && (
                  <CmTh>{posItemColumn.promotionOneFreePosCode.label}</CmTh>
                )}
            </CmTableHeader>
            <CmTbody>
              {confirmPosItems.map((posItem, i) => (
                <CmTableBodyRow key={i}>
                  <CmTd>{posItem.item_name}</CmTd>
                  {/* TODO 互換性がないというエラーが出るため、下記`as`のHACK的なやり方で対応をする。typescriptのverv4.3.5であれば解消できる様子なのでその際にasを削除対応をとる */}
                  {(
                    mappingPosDataLevel[posDataLevel]
                      .tds as MappingPosDataLevelTds[]
                  ).map((td) => (
                    <CmTd key={td}>{posItem[td]}</CmTd>
                  ))}
                  <CmTd>{posItem.posCode}</CmTd>
                  <CmTd>{posItem.promotionOneFreePosCode}</CmTd>
                </CmTableBodyRow>
              ))}
            </CmTbody>
          </CmTable>
        </CmModalBody>
        <CmModalFooter>
          <CmButton variant="outline" mr={4} onClick={onClose}>
            キャンセル
          </CmButton>
          <CmButton
            width={100}
            onClick={() => handleUpdatePosCode(posProviderId, confirmPosItems)}
          >
            登録
          </CmButton>
        </CmModalFooter>
      </CmModal>
    </>
  );
};
